import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Footer.css';
import useLanguage from '../hooks/useLanguage';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4">
            <div className="footer-company">
              <img src="/logo-levitztax.png" alt="LevitzTax" style={{ maxWidth: '180px', marginBottom: '1rem', filter: 'brightness(0) invert(1)' }} />
              <p className="text-white-50" style={{ whiteSpace: 'pre-line' }}>
                {t('footer', 'description')}
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 mb-4">
            <h5 className="text-white mb-3">{t('footer', 'servicesTitle')}</h5>
            <ul className="footer-links">
              <li><a href="#services">{t('footer', 'footerServiceTax')}</a></li>
              <li><a href="#services">{t('footer', 'footerServiceFBAR')}</a></li>
              <li><a href="#services">{t('footer', 'footerServiceStreamlined')}</a></li>
              <li><a href="#services">{t('footer', 'footerServiceDual')}</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-6 mb-4">
            <h5 className="text-white mb-3">{t('footer', 'companyTitle')}</h5>
            <ul className="footer-links">
              <li><a href="#about">{t('footer', 'footerAbout')}</a></li>
              <li><a href="#contact">{t('footer', 'footerContact')}</a></li>
            </ul>
          </div>

          <div className="col-lg-4 mb-4">
            <h5 className="text-white mb-3">{t('footer', 'contactTitle')}</h5>
            <div className="footer-contact">
              <div className="contact-item">
                <i className="bi bi-geo-alt text-warning"></i>
                <div>
                  <strong>{t('footer', 'jerusalem')}</strong><br/>
                  <span dir="ltr">Kanfei Nesharim 68, Jerusalem, Israel</span>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-telephone text-warning"></i>
                <div dir="ltr">058-768-1185 (IL) | +1 (516) 323-7928 (US)</div>
              </div>
              <div className="contact-item">
                <i className="bi bi-envelope text-warning"></i>
                <div>Bentzy@levitztax.com</div>
              </div>
              <div className="contact-item">
                <i className="bi bi-globe text-warning"></i>
                <div><a href="https://www.levitztax.com" className="text-white-50">www.levitztax.com</a></div>
              </div>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="text-white-50 mb-0">
              {t('footer', 'copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
